import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './header';

function MobileBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="bg-(--color-accent)/10 border-(--color-accent)/30 flex items-start gap-3 border-b px-4 py-3 lg:hidden">
      <svg
        className="text-(--color-accent) mt-0.5 h-4 w-4 shrink-0"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0H3"
        />
      </svg>
      <p className="text-(--color-text-secondary) flex-1 text-xs leading-relaxed">
        Para uma melhor visualização dos dados, recomendamos acessar pelo{' '}
        <span className="text-(--color-text-primary) font-medium">
          computador
        </span>
        .
      </p>
      <button
        onClick={() => setDismissed(true)}
        aria-label="Fechar aviso"
        className="text-(--color-text-secondary) hover:text-(--color-text-primary) mt-0.5 shrink-0 transition-colors"
      >
        <svg
          className="h-3.5 w-3.5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18 18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
}

export function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <MobileBanner />
      <main className="flex-1 py-6 md:pt-20">
        <Outlet />
      </main>
    </div>
  );
}
